import moment from "moment";
import React from "react";
import { Chart } from "react-google-charts";

const SPCScatterLineChart = ({ data = { checkPoints: [] }, IsSPC = false }) => {
  const getData = () => {
    // Build header based on IsSPC
    const header = IsSPC
      ? ["DateTime", "Dimension", "Mean", "Min", "Max", "Standard"]
      : ["DateTime", "Dimension", "Min", "Max", "Standard"];
    const chartData = [header];

    data.dataPoints.forEach((point) => {
      const date = new Date(point.DateTime);
      chartData.push(
        IsSPC
          ? [
              moment(date).format("MMM DD, HH:mm"),
              point.Dimension,
              data.mean,
              data.Min,
              data.Max,
              data.Standard,
            ]
          : [
              moment(date).format("MMM DD, HH:mm"),
              point.Dimension,
              data.Min,
              data.Max,
              data.Standard,
            ]
      );
    });

    return chartData;
  };

  // Calculate min dimension to start Y-axis
  const minDimension = Math.min(
    ...data.dataPoints.map((p) => p.Dimension),
    data.Min,
    data.Standard
  );

  // Series mapping based on IsSPC
  const series = IsSPC
    ? {
        0: { type: "line", color: "#3366CC", lineWidth: 1.5, pointSize: 4 }, // Dimension
        1: { type: "line", color: "red", lineWidth: 1.5, pointSize: 4 },     // Mean
        2: { type: "line", color: "green", lineWidth: 1.5, pointSize: 4 },   // Min
        3: { type: "line", color: "orange", lineWidth: 1.5, pointSize: 4 },  // Max
        4: { type: "line", color: "blue", lineWidth: 1.5, pointSize: 4 },    // Standard
      }
    : {
        0: { type: "line", color: "#3366CC", lineWidth: 1.5, pointSize: 4 }, // Dimension
        1: { type: "line", color: "green", lineWidth: 1.5, pointSize: 4 },   // Min
        2: { type: "line", color: "orange", lineWidth: 1.5, pointSize: 4 },  // Max
        3: { type: "line", color: "blue", lineWidth: 1.5, pointSize: 4 },    // Standard
      };

  const options = {
    title: `${data.checkpoint} SPC Chart`,
    legend: { position: "top" },
    chartArea: { left: 80, right: 40, bottom: 125, top: 50 },
    hAxis: {
      title: "Date & Time",
      slantedText: true,
      slantedTextAngle: 85,
      showTextEvery: 1,
      textStyle: { fontSize: 12 },
    },
    vAxis: {
      title: data.checkpoint,
      viewWindow: { min: minDimension },
      textStyle: { fontSize: 12 },
    },
    series,
    pointSize: 8, // global fallback
  };

  return (
    <div style={{ width: "100%", margin: "auto", marginBottom: 40 }}>
      {data.dataPoints?.length > 0 ? (
        <Chart
          chartType="ComboChart"
          width="100%"
          height="600px"
          data={getData()}
          options={options}
        />
      ) : (
        <p>No Data Available</p>
      )}
    </div>
  );
};

export default SPCScatterLineChart;
